import React from 'react';
import PropTypes from 'prop-types';
import { navigate } from 'gatsby';

const NavItem = ({ children, id, dest, onClick, modifier, divided }) => {

  const handleClick = e => {

    if ( typeof onClick === 'function' ) {

      onClick( e );

    }

    // TODO: this should not be needed and instead use an instance of WonderLink
    //       as the <a

    if ( dest.charAt( 0 ) === '/' ) {

      navigate( dest );

    } else {

      window.location = dest;

    }

  };

  const modifierClass = modifier ? `e84-${ modifier }-nav-item` : '';

  let className = `e84-nav-item ${ modifierClass }`;

  if ( divided ) {

    className = `${ className } ${ modifierClass }-divided`;

  }

  return (
    <li className={ className } data-id={ id }>
      <a href={ dest }
        onClick={ handleClick }
        className={ `e84-nav-item-link ${ modifierClass }-link` }
      >
        { children }
      </a>
    </li>
  );

};

NavItem.propTypes = {
  children: PropTypes.string.isRequired,
  id: PropTypes.string,
  dest: PropTypes.string.isRequired,
  modifier: PropTypes.string,
  onClick: PropTypes.func,
  divided: PropTypes.bool,
};

export default NavItem;
